"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _consts = require("../consts");

var getDirection = function getDirection(direction) {
  if (!direction) {
    return false;
  }

  return Object.values(_consts.DIRECTIONS).indexOf(direction) !== -1 ? direction : _consts.DIRECTIONS.ROW;
};

var _default = getDirection;
exports.default = _default;